import { onMounted, onUnmounted, reactive, readonly, type Ref, toRefs } from "vue";

import { ResizeObserverPolyfill as ResizeObserver } from "@/polyfills";

export function useResizeObserver(target: Ref<HTMLElement | undefined>) {
  const state = reactive({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  });

  const observer = new ResizeObserver(([entry]) => {
    state.x = entry.contentRect.x;
    state.y = entry.contentRect.y;
    state.width = entry.contentRect.width;
    state.height = entry.contentRect.height;
    state.top = entry.contentRect.top;
    state.right = entry.contentRect.right;
    state.bottom = entry.contentRect.bottom;
    state.left = entry.contentRect.left;
  });

  const observe = (): void => {
    if (target.value) {
      observer.observe(target.value);
    }
  };

  const unobserve = (): void => {
    if (target.value) {
      observer.unobserve(target.value);
    }
  };

  onMounted(observe);

  onUnmounted(unobserve);

  return {
    ...toRefs(readonly(state)),
    observe,
    unobserve
  };
}
